import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class staticPagesView_template extends vnTemplate {

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            description: ko.observable(""),
            permalink: ko.observable(""),
            content: ko.observable(""),
            style: ko.observable(""),
            indexed: ko.observable(false),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            onClickEditStaticPage: function (data, event) {
                self.onClickEditStaticPage(data.id());
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`


            <div class="w-form w-form-large">
                
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn">
                         <a class="btn icon only-icon i-link" data-bind="event: { click: viewOnWebsite }"></a>
                         <button data-bind="event: { click: onClickEditStaticPage }" class="btn icon i-edit"  type="button">Edit Static Page</button>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                   
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Name</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: name"></span>
                                </dd>
                                <dt>
                                    <span>Permalink</span>
                                </dt>
                                <dd class="no-cap">
                                    <span data-bind="text: permalink"></span>
                                </dd>  
                                <dt class="full-width">
                                    <span>Description</span>
                                </dt>
                                <dd class="no-cap full-width">
                                    <span data-bind="text: description"></span>
                                </dd>  
                             </dl>
                         </div>
                    </div>
                    <div class="form-body">
                       
                        <div class="form-group">
                            <dl class="double-list">
                               <dt>
                                    <span>Indexed</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: indexed"></span>
                                </dd> 
                                <dt>
                                    <span>Date Created</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: dateCreated().substring(0, 10)"></span>
                                </dd> 
                                <dt>
                                    <span>Date Updated</span>
                                </dt>
                                <dd>
                                    <span  data-bind="text: dateUpdated().substring(0, 10)"></span>
                                </dd> 
                            </dl>
                        </div>
                    </div>
                </div>
        `);
    }

    protected setStaticPageData(staticPage) {
        this.getTemplateViewModel().id(staticPage.id);
        this.getTemplateViewModel().name(staticPage.name);
        this.getTemplateViewModel().description(staticPage.description);
        this.getTemplateViewModel().permalink(staticPage.permalink);
        this.getTemplateViewModel().content(staticPage.content);
        this.getTemplateViewModel().style(staticPage.style);
        this.getTemplateViewModel().indexed(staticPage.indexed);
        this.getTemplateViewModel().dateCreated(staticPage.dateCreated);
        this.getTemplateViewModel().dateUpdated(staticPage.dateUpdated);
    }

    protected getTemplateName(): string {
        return "staticPagesView_template";
    }

    protected onClickEditStaticPage(id: any): any {
        this.caller.onClickEditStaticPage(id)
    }

    private viewOnWebsite(value) {

        //prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();
        this.caller.viewOnWebsite(value.permalink());
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }


}


// WEBPACK FOOTER //
// ./js/components/templates/staticPagesView_template.ts